/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'AppDownloadApk',
    path: '/app-download/apk',
    component: () =>
      import(
        /* webpackChunkName: "AppDownloadApk" */ '@/views/app-download/apk'
      ),
    meta: { title: '小拉出行' },
  },
  {
    name: 'AppDownloadApk',
    path: '/app-download/wx',
    component: () =>
      import(
        /* webpackChunkName: "AppDownloadApk" */ '@/views/app-download/wx'
      ),
    meta: { title: '小拉出行' },
  },
];
